import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import AppLayout from './components/AppLayout';
import Resume from './components/Resume';
import NotFound from './components/NotFound';
import CommandPalette from './components/CommandPalette';
import { DomainData } from './types';
import yaml from 'js-yaml';
import './cyber-theme.css';

// Lazy load TerminalPage for the /terminal and /cv routes
const TerminalPage = lazy(() => import('./components/TerminalPage'));

const App: React.FC = () => {
  const [treeData, setTreeData] = useState<DomainData | null>(null);

  useEffect(() => {
    // Load the YAML domain data for CommandPalette
    fetch('/myDomains.yaml')
      .then(response => response.text())
      .then(data => {
        const parsedData = yaml.load(data) as DomainData;
        setTreeData(parsedData);
      })
      .catch(error => console.error('Error loading YAML data:', error));
  }, []);

  return (
    <>
      <Routes>
        {/* Home has its own layout with stateful header/footer */}
        <Route index element={<Home />} />

        {/* Terminal CV routes - standalone fullscreen terminal */}
        <Route path="terminal" element={
          <Suspense fallback={<div style={{ background: '#0a0a0f', height: '100vh' }} />}>
            <TerminalPage />
          </Suspense>
        } />
        <Route path="cv" element={
          <Suspense fallback={<div style={{ background: '#0a0a0f', height: '100vh' }} />}>
            <TerminalPage />
          </Suspense>
        } />

        {/* Other pages use AppLayout with navigation mode */}
        <Route element={<AppLayout />}>
          <Route path="resume" element={<Resume />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>

      {/* Global Command Palette */}
      <CommandPalette data={treeData} />
    </>
  );
};

export default App;
